var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mng-vr-scene2"},[_c('VrScene',{ref:"vrScene",staticClass:"mng-vr-scene__stage",attrs:{"scene-id":_vm.$route.params.modelId},on:{"initialized":_vm.onInitialized,"right-click":_vm.onPlaceLabel,"label-clicked":_vm.onClickLabel,"on_shoted":_vm.onShoted}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }